<template>
  <picker-field :label="label" :display="display" :value="value" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in filteredItems"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>
              {{item.vb_vrName}}
              <span v-if="item.vb_surplus > 0">（剩余{{ item.vb_surplus }}小时）</span>
            </p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: {
      type: String,
      default: "假期类型"
    },
    value: String
  },
  data() {
    return {
      display: null,
      items: []
    };
  },
  computed: {
    filteredItems() {
      var me = this,
        items = me.items;
      if (items.length > 0) {
        return items.filter(item => item.qa_type == 0 || item.vb_surplus > 0 || !item.id);
      }
      return items;
    }
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.vb_vrName);
      me.$emit("select", item);
      me.display = item.display || item.vb_vrName;
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/oa/vacationRule/getCombo",
        params: {
          number: 1,
          size: 100
        }
      }).then(function(res) {
        if (res.success) {
          me.items = res.data ? res.data : [];
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>